<script lang="ts">
export default defineComponent({
  props: {
    as: { type: String, default: 'div' },
    open: { type: Boolean, required: false, default: false },
    outsideClose: { type: Boolean, required: false, default: false }
  },
  setup({ as, open, outsideClose }, { slots, expose }) {
    const state = ref(open)
    const container = ref<HTMLElement | null>(null)
    const isOpen = computed(() => state.value)

    const { setState, toggleState, init, destroy, outsideClose: groupOutsideClose } = assertInject(DisclosureGroupInjection, {
      toggleState (state: Ref<boolean>) {
        state.value = !state.value
      },
      setState (state: Ref<boolean>, value: boolean) {
        state.value = value
      },
      outsideClose
    })

    init?.(state)
    
    const toggle = () => toggleState(state)

    const expand = () => setState(state, true)

    const close = () => setState(state, false)

    groupOutsideClose && onClickOutside(container, () => {
      isOpen.value && close()
    })

    onBeforeUnmount(() => {
      destroy?.(state)
    })

    provide(DisclosureInjection, {
      isOpen,
      toggle,
      expand,
      close
    })

    expose({
      toggle,
      expand,
      close,
      container
    })
    
    return () => 
      h(
        as,
        {
          ref: container,
        },
        slots.default!({
          isOpen
        })
      )
  },
})
</script>
